import { CodeSystem } from '@heidi/coding/contracts';
import { Region } from '@heidi/schema/ml-scribe';

type CodesetConfig = {
  name: string;
  nameWithCodingSuffix: string;
  regions: Region[];
};

/**
 * Display labels for each clinical code system.
 * These labels are used when generating markdown representations of clinical codes.
 */
export const CODE_SYSTEM_CONFIG: Record<CodeSystem, CodesetConfig> = {
  [CodeSystem.snomed_uk]: {
    name: 'SNOMED-UK',
    nameWithCodingSuffix: 'SNOMED coding:',
    regions: [Region.UK],
  },
  [CodeSystem.icd_10_cm]: {
    name: 'ICD-10-CM',
    nameWithCodingSuffix: 'ICD-10-CM coding:',
    regions: [Region.US],
  },
  [CodeSystem.mbs_au]: {
    name: 'MBS-AU',
    nameWithCodingSuffix: 'MBS-AU coding:',
    regions: [Region.AU],
  },
  [CodeSystem.icd_10_am]: {
    name: 'ICD-10-AM',
    nameWithCodingSuffix: 'ICD-10-AM coding:',
    regions: [Region.AU],
  },
  [CodeSystem.achi_13_au]: {
    name: 'ACHI-13-AU',
    nameWithCodingSuffix: 'ACHI-13-AU coding:',
    regions: [Region.AU],
  },
  [CodeSystem.icd_10_uk]: {
    name: 'ICD-10-UK',
    nameWithCodingSuffix: 'ICD-10-UK coding:',
    regions: [Region.UK],
  },
  [CodeSystem.opcs410_uk]: {
    name: 'OPCS-410-UK',
    nameWithCodingSuffix: 'OPCS-410-UK coding:',
    regions: [Region.UK],
  },
  [CodeSystem.icd_9_ca]: {
    name: 'ICD-9-CA',
    nameWithCodingSuffix: 'ICD-9-CA coding:',
    regions: [Region.CA],
  },
  [CodeSystem.icd_9_cm]: {
    name: 'ICD-9-CM',
    nameWithCodingSuffix: 'ICD-9-CM coding:',
    regions: [Region.CA],
  },
  [CodeSystem.cpt_2025]: {
    name: 'CPT-2025',
    nameWithCodingSuffix: 'CPT-2025 coding:',
    regions: [Region.US],
  },
  [CodeSystem.cpt_2026]: {
    name: 'CPT-2026',
    nameWithCodingSuffix: 'CPT-2026 coding:',
    regions: [Region.US],
  },
  [CodeSystem.icd_10_gm]: {
    name: 'ICD-10-GM',
    nameWithCodingSuffix: 'ICD-10-GM coding:',
    regions: [Region.EU],
  },
  [CodeSystem.cim_10_fr]: {
    name: 'CIM-10-FR',
    nameWithCodingSuffix: 'CIM-10-FR coding:',
    regions: [Region.EU],
  },
  [CodeSystem.cie_10_es]: {
    name: 'CIE-10-ES',
    nameWithCodingSuffix: 'CIE-10-ES coding:',
    regions: [Region.EU],
  },
  [CodeSystem.icd_10_za]: {
    name: 'ICD-10-ZA',
    nameWithCodingSuffix: 'ICD-10-ZA coding:',
    regions: [Region.EU],
  },
  [CodeSystem.orpha]: {
    name: 'ORPHA',
    nameWithCodingSuffix: 'ORPHA coding:',
    regions: [Region.EU],
  },
  [CodeSystem.cim_10_mc]: {
    name: 'CIM-10-MC',
    nameWithCodingSuffix: 'CIM-10-MC coding:',
    regions: [Region.EU],
  },
  [CodeSystem.cim_10_scp]: {
    name: 'CIM-10-SCP',
    nameWithCodingSuffix: 'CIM-10-SCP coding:',
    regions: [Region.EU],
  },
  [CodeSystem.ohip_dx]: {
    name: 'OHIP-DX',
    nameWithCodingSuffix: 'OHIP-DX coding:',
    regions: [Region.CA],
  },
  [CodeSystem.e_m]: {
    name: 'E/M Determinator',
    nameWithCodingSuffix: 'E/M level:',
    regions: [Region.US],
  },
  [CodeSystem.icd_10_qa]: {
    name: 'ICD-10-QA',
    nameWithCodingSuffix: 'ICD-10-QA coding:',
    regions: [Region.EU],
  },
  [CodeSystem.icd_10_it]: {
    name: 'ICD-10-IT',
    nameWithCodingSuffix: 'ICD-10-IT coding:',
    regions: [Region.EU],
  },
  [CodeSystem.cpt_qa]: {
    name: 'CPT-QA',
    nameWithCodingSuffix: 'CPT-QA coding:',
    regions: [Region.EU],
  },
};
